// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3iVv0","selects":"Documents_selects__3cQmU"};